import { stripUrlProtocol } from '@smartproxy-web/shared/utils';
import { AnchorHTMLAttributes } from 'react';

import { currentLocaleConfig } from '@/lib/i18n/localeSpecific';

export function getLinkRelFromConfig(
  urlString?: string
): AnchorHTMLAttributes<'a'>['rel'] {
  if (!urlString?.startsWith('http')) return;
  const noFollowExclusions = currentLocaleConfig().noFollowExclusions;

  const isUrlExcluded = noFollowExclusions.some((domain) => {
    const normalizedUrlString = stripUrlProtocol(urlString);
    const normalizedExcludedUrlString = stripUrlProtocol(domain);

    try {
      const url = new URL(`http://${normalizedUrlString}`);
      const excludedUrl = new URL(`http://${normalizedExcludedUrlString}`);

      const doDomainsMatch = url.hostname === excludedUrl.hostname;
      const doPathnamesPartiallyMatch = url.pathname.startsWith(
        excludedUrl.pathname
      );

      return doDomainsMatch && doPathnamesPartiallyMatch;
    } catch (error) {
      return false;
    }
  });
  if (isUrlExcluded) return;
  return 'nofollow';
}
